/* eslint-disable no-unused-expressions */
import React from 'react';

import './index.scss';

const BasicErrorModal = ({modalId, unsubmitAction, cancelAction}) => {
  return(
    <div className='cb-modal' id={`${modalId}`} aria-hidden='true'
      data-cb-apricot='modal'>
      <div className='cb-modal-overlay' tabIndex='-1'>
        <div className='cb-modal-container submitModal_container' role='dialog' aria-modal='true' aria-labelledby='submitModalTitleError' aria-describedby='submitDlgDscError'>
          <div className='cb-modal-header'>
            <h2 className='cb-modal-title submitModal_container-title' id='submitModalTitleError'>
              <i className='cb-icon cb-icon-circular cb-exclamation cb-red1-color' aria-hidden='true' />
              <span style={{marginLeft: '20px'}}>We were unable to unsubmit your category.</span>
            </h2>

            {/* <!-- close button --> */}
            <button type='button' onClick={cancelAction} className='cb-btn cb-btn-square cb-btn-greyscale cb-btn-close' aria-describedby='submitModalTitleError' data-cb-modal-close>
              <span className='cb-icon cb-x-mark' aria-hidden='true' />
              <span className='sr-only'>Close</span>
            </button>
          </div>
          <div className='cb-modal-content submitModal_container-content' id='submitDlgDscError'>
            {/* <p>Please reload page and try again.</p> */}
          </div>
          <div className='cb-modal-footer'>
            <div className='cb-btn-row subBtnRow' id='basicErrorSubBtnRow'>
              <button type='button' className='cb-btn cb-btn-naked' onClick={cancelAction} data-cb-modal-close aria-label='Close'>Close</button>
              <button
                type='button'
                className='cb-btn cb-btn-primary'
                onClick={unsubmitAction}
                data-cb-modal-close
                data-testid='confirmunsubmitbutton'
                aria-label='Continue without saving'>
                Try Again?
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BasicErrorModal;